module.exports = __webpack_public_path__ + "media/online.f5dc75dc.mp3";